import { GD } from "src/GD";

/** Resolve addresses on demand; proxy addresses are stable, legacy issuer addresses may expire. */
export class CryptoService {
	constructor() {
		GD.REQ_CRYPTO_COINS.listener = this.coins;
		GD.REQ_CRYPTO_QUOTE.listener = this.quote;
		GD.REQ_CRYPTO_ADDRESS.listener = this.address;
		GD.REQ_CRYPTO_DEPOSITS.listener = this.deposits;
	}

	private coins = async (): Promise<IAPIResponse<ICryptoCoin[]>> =>
		(await GD.REQ_API.request({ httpMethod: "POST", method: "crypto/coins", data: {} })) as IAPIResponse<ICryptoCoin[]>;

	private quote = async (body: { coin_key: string; amount: number }): Promise<IAPIResponse<ICryptoQuote>> =>
		(await GD.REQ_API.request({ httpMethod: "POST", method: "crypto/quote", data: body })) as IAPIResponse<ICryptoQuote>;

	private address = async (body: void | { coin_key?: string }): Promise<IAPIResponse<ICryptoAddress>> =>
		(await GD.REQ_API.request({ httpMethod: "POST", method: "crypto/address", data: body ?? {} })) as IAPIResponse<ICryptoAddress>;

	private deposits = async (): Promise<IAPIResponse<ICryptoDeposit[]>> =>
		(await GD.REQ_API.request({ httpMethod: "POST", method: "crypto/deposits", data: {} })) as IAPIResponse<ICryptoDeposit[]>;
}
